import { useQueryClient } from '@tanstack/react-query'
import { PatientService } from 'src/services/patient.service'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useNotification } from 'src/providers/notification.provider'
import { CurecallConfirmationModal, ECurecallNotificationAppearance } from '@honestica/curecall-ui'

type TConsentModal = {
  onClose: VoidFunction
  patientId: number
}

const ConsentModal = ({ onClose, patientId }: TConsentModal) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { projectId } = useParams()
  const { notify } = useNotification()

  const handleConfirm = async () => {
    try {
      await PatientService.sendConsent(Number(projectId), patientId)
      notify({
        message: t('components.patient.patient-file.header.consent.consent-sent-message'),
        title: t('components.patient.patient-file.header.consent.consent-sent-title'),
        appearance: ECurecallNotificationAppearance.SUCCESS,
      })
      queryClient.invalidateQueries({ queryKey: ['patients', projectId, patientId] })
      onClose()
    } catch (error) {
      notify({ title: t('common.actions.error'), message: error, appearance: 'ERROR' })
    }
  }

  return (
    <CurecallConfirmationModal
      color="ALERT"
      title={t('components.patient.patient-file.header.consent.send-consent-modale-title')}
      isOpen
      cancelButtonLabel={t('common.actions.cancel')}
      confirmButtonLabel={t('common.actions.confirm')}
      onCancel={onClose}
      onConfirm={handleConfirm}
    >
      {t('components.patient.patient-file.header.consent.send-consent-question')}
    </CurecallConfirmationModal>
  )
}

export default ConsentModal
